import React, { createContext, useEffect, useState } from "react";
import CustomTable from "../../../../components/Table/CustomTable";
import Modal1 from "../../../../components/DIsplay/Modal/Modal1";
import Icon from "../../../../components/HOC/Icon";
import CreateMarkup from "./CreateMarkup";
import { Link } from "react-router-dom";
import Button1 from "../../../../components/form/Button1";
import getFlightPriceAdjustments from "../../../../controllers/flightPriceAdjustment/getFlightPriceAdjustments";
import { IconButton, Switch } from "@mui/material";
// import activateFlightAdjustment from "../../../../controllers/flightPriceAdjustment/activateFlightAdjustment";
// import deactivateFlightAdjustment from "../../../../controllers/flightPriceAdjustment/deactivateFlightAdjustment";
import MarkupDelete from "./MarkupDelete";
import { getTestLevel } from "../../../../utils/testLevel";
import { def } from "../../../../config";
import useAccount from "../../../../hooks/useAccount";
import { MdContentCopy } from "react-icons/md";
import createFlightPriceAdjustment from "../../../../controllers/flightPriceAdjustment/createFlightPriceAdjustment";
import { enqueueSnackbar } from "notistack";
import updateFlightPriceAdjustment from "../../../../controllers/flightPriceAdjustment/updateFlightPriceAdjustment";
import CommonFreeTextInput from "../../../../components/common/inputs/CommonFreeTextInput";
import { Clear, Search } from "@mui/icons-material";
import OverrideMarkupModal from "./OverrideMarkupModal";

const ActionContext = createContext();

function isOverrideMarkup(markup) {
  return markup?.override === true || markup?.override === "true";
}
export default function FlightMarkup({ hideMoreOptions }) {
  const [open, setOpen] = useState(false);
  const [isOverride, setIsOverride] = useState(false);
  const [reopenOverrideAfterSave, setReopenOverrideAfterSave] = useState(false);
  const [openOverrideModal, setOpenOverrideModal] = useState(false);
  const [overrideMarkups, setOverrideMarkups] = useState([]);
  const [overrideLoading, setOverrideLoading] = useState(false);
  const [overrideStatusLoadingId, setOverrideStatusLoadingId] = useState(null);
  const [editObj, setEditObj] = useState();
  const [deleteObj, setDeleteObj] = useState();
  const [flightMarkups, setFlightMarkups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFareType, setSelectedFareType] = useState("All");
  const [searchDraft, setSearchDraft] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const { checkPermission } = useAccount();

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 50,
    rowCount: 0,
  });

  const devStage = getTestLevel(def?.devStatus);

  function openCreateMarkup({ override = false } = {}) {
    setIsOverride(override);
    setOpen(true);
  }

  function closeCreateMarkup() {
    setOpen(false);
    setIsOverride(false);
    setReopenOverrideAfterSave(false);
  }

  async function reloadMarkups() {
    await load();
    if (reopenOverrideAfterSave) {
      setReopenOverrideAfterSave(false);
      setOpenOverrideModal(true);
    }
  }

  async function fetchOverrideMarkups() {
    const query = new URLSearchParams({
      limit: 500,
      offset: 0,
      filterBy: "override",
      filterValue: true,
    }).toString();
    const res = await getFlightPriceAdjustments(query);
    if (res.return && Array.isArray(res.data?.data?.data)) {
      const overrides = res.data.data.data.filter(isOverrideMarkup);
      setOverrideMarkups(overrides);
      return overrides;
    }
    setOverrideMarkups([]);
    return [];
  }

  async function loadOverrideMarkups() {
    setOverrideLoading(true);
    const overrides = await fetchOverrideMarkups();
    setOverrideLoading(false);
    return overrides;
  }

  async function handleOverrideClick() {
    await loadOverrideMarkups();
    setOpenOverrideModal(true);
  }

  function handleEditOverride(markup) {
    setOpenOverrideModal(false);
    setIsOverride(true);
    setEditObj(markup);
  }

  function handleDeleteOverride(markup) {
    setOpenOverrideModal(false);
    setDeleteObj(markup);
  }

  async function handleOverrideToggleStatus(enabled, markup) {
    setOverrideStatusLoadingId(markup?._id);
    const res = await updateFlightPriceAdjustment(markup._id, {
      status: enabled ? "Active" : "Inactive",
    });
    setOverrideStatusLoadingId(null);
    if (res?.return) {
      enqueueSnackbar(`Override markup ${enabled ? "enabled" : "disabled"}`, {
        variant: "success",
      });
      await load();
      await loadOverrideMarkups();
    } else {
      enqueueSnackbar(res?.msg, { variant: "error" });
    }
  }

  function handleCreateFromOverrideModal() {
    setOpenOverrideModal(false);
    setReopenOverrideAfterSave(true);
    openCreateMarkup({ override: true });
  }

  useEffect(() => {
    load();
    //eslint-disable-next-line
  }, [
    paginationModel?.page,
    paginationModel?.pageSize,
    selectedFareType,
    searchKeyword,
  ]);

  function submitMarkupSearch() {
    const next = searchDraft.trim();
    setSearchKeyword(next);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }

  function clearMarkupSearch() {
    setSearchDraft("");
    setSearchKeyword("");
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }

  const hasSearchFilter = Boolean(searchKeyword || searchDraft.trim());

  async function load() {
    if (open) closeCreateMarkup();
    setEditObj();

    const query = {
      limit: paginationModel?.pageSize,
      offset: paginationModel?.page * paginationModel?.pageSize,
    };
    if (selectedFareType !== "All") {
      query.filterBy = "fareType";
      query.filterValue = selectedFareType;
    }

    if (searchKeyword) {
      query.searchBy = "name,suppliers,airlines,priceType";
      query.keyword = searchKeyword;
    }
    const queryString = new URLSearchParams(query)?.toString();

    setLoading(true);
    const res = await getFlightPriceAdjustments(queryString);
    setLoading(false);
    if (res.return) {
      if (Array.isArray(res.data?.data?.data)) {
        setFlightMarkups(
          res.data.data.data.filter((markup) => !isOverrideMarkup(markup)),
        );
      }

      setPaginationModel({
        ...paginationModel,
        rowCount: res?.data?.data?.meta?.total,
      });
    }
    await fetchOverrideMarkups();
  }

  async function changeStatus(value, param) {
    setLoading(true);
    let res;
    if (value) {
      res = await updateFlightPriceAdjustment(param._id, {
        status: "Active",
      });
    } else {
      res = await updateFlightPriceAdjustment(param._id, {
        status: "Inactive",
      });
    }
    setLoading(false);
    if (res?.return) {
      load();
    } else {
      enqueueSnackbar(res?.msg, { variant: "error" });
    }
  }

  const columns = [
    { field: "name", headerName: "Mark-up name", flex: 1 },
    {
      field: "suppliers",
      headerName: "Supplier(s)",
      flex: 1,
      renderCell: (params) => {
        return <div>{(params?.value || [])?.join(", ")}</div>;
      },
    },
    { field: "type", headerName: "Type", flex: 1 },
    { field: "amount", headerName: "Amount", flex: 1 },
    { field: "method", headerName: "Method", flex: 1 },
    {
      field: "status",
      headerName: "Action",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        return (
          <ActionContext.Provider
            value={{
              setEditObj: (obj) => {
                setIsOverride(isOverrideMarkup(obj));
                setEditObj(obj);
              },
              setDeleteObj,
              changeStatus,
              load,
            }}
          >
            <ActionCol params={params.row} load={load} />
          </ActionContext.Provider>
        );
      },
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between flex-wrap items-center gap-4">
        <div className="flex gap-2 max-w-full overflow-x-auto pb-2">
          {!hideMoreOptions && (
            <>
              {checkPermission([
                "update:flight-price-adjustment",
                "create:flight-price-adjustment",
              ]) ? (
                <Link to="?type=Flights" className={"btn"}>
                  Flights
                </Link>
              ) : null}
              {/* {getTestLevel() < getTestLevel('qa') ? ( */}
              <Link to="?type=Stays" className={"btn-theme-light rounded-md"}>
                Stays
              </Link>
              {/* ) : null} */}
              {/* {devStage < 1 ? ( */}
              <Link to="?type=Tours" className={"btn-theme-light rounded-md"}>
                Tours
              </Link>
              <Link to="?type=Stays" className={"btn-theme-light rounded-md"}>
                Package
              </Link>
              {/* ) : null} */}
              <Link
                to="?type=Insurance"
                className={"btn-theme-light rounded-md"}
              >
                Insurance
              </Link>
              <Link
                to="?type=Postticketing"
                className={"btn-theme-light rounded-md"}
              >
                Post-Ticketing
              </Link>
              <Link to="?type=Guests" className={"btn-theme-light rounded-md"}>
                Guests
              </Link>
            </>
          )}
        </div>
        {/* <h5 className='text-primary/70'>Created Mark ups</h5> */}
        <div className="flex gap-2 flex-1 items-center justify-end">
          <div>
            {checkPermission(["create:flight-price-adjustment"]) ? (
              <Button1 className="w-fit" onClick={() => openCreateMarkup()}>
                Create new markup
              </Button1>
            ) : null}
          </div>
          <Modal1
            open={open}
            setOpen={(val) => (val ? setOpen(true) : closeCreateMarkup())}
            modalBorderRadius="rounded-2xl"
          >
            <CreateMarkup
              forType={"Flights"}
              reload={reloadMarkups}
              hideMoreOptions={hideMoreOptions}
              override={isOverride}
              footer={
                <div className="flex flex-1">
                  <Button1
                    onClick={closeCreateMarkup}
                    className="btn-theme-light"
                  >
                    Cancel
                  </Button1>
                </div>
              }
            />
          </Modal1>
        </div>
      </div>

      {checkPermission(["read:flight-price-adjustment"]) ? (
        <>
          <div className="mt-3 flex flex-col gap-3">
            <div className="flex gap-2 flex-wrap items-center justify-between">
              <div className="flex gap-2 flex-wrap">
                {["All", "Published", "Negotiated", "Corporate"]?.map(
                  (fareType) => (
                    <button
                      key={fareType}
                      type="button"
                      className={
                        selectedFareType === fareType
                          ? "btn"
                          : "btn-theme-light rounded-md"
                      }
                      onClick={() => {
                        setSelectedFareType(fareType);
                        setPaginationModel((prev) => ({ ...prev, page: 0 }));
                      }}
                    >
                      {fareType}
                    </button>
                  ),
                )}
              </div>
              {checkPermission(["create:flight-price-adjustment"]) ? (
                <button
                  type="button"
                  className={`btn-theme-light rounded-md inline-flex items-center gap-2 ${
                    overrideMarkups.length ? "ring-2 ring-indigo-200" : ""
                  }`}
                  onClick={handleOverrideClick}
                  disabled={overrideLoading}
                >
                  {overrideLoading
                    ? "Loading..."
                    : `Override Markup${overrideMarkups.length ? ` (${overrideMarkups.length})` : ""}`}
                  {overrideMarkups.some((m) => m.status === "Active") ? (
                    <span className="inline-flex h-2 w-2 rounded-full bg-indigo-500" />
                  ) : null}
                </button>
              ) : null}
            </div>
            <form
              className="flex w-full max-w-md flex-wrap items-end gap-2"
              onSubmit={(e) => {
                e.preventDefault();
                submitMarkupSearch();
              }}
            >
              <div className="min-w-[200px] flex-1">
                <CommonFreeTextInput
                  label="Search"
                  placeholder="Name or supplier"
                  value={searchDraft}
                  onChange={setSearchDraft}
                />
              </div>
              <IconButton
                type="submit"
                color="primary"
                aria-label="Search markups"
                className="mb-0.5 shrink-0"
              >
                <Search />
              </IconButton>
              {hasSearchFilter ? (
                <IconButton
                  type="button"
                  aria-label="Clear search"
                  className="mb-0.5 shrink-0 text-gray-600"
                  onClick={clearMarkupSearch}
                >
                  <Clear />
                </IconButton>
              ) : null}
            </form>
          </div>
          <CustomTable
            rows={flightMarkups}
            columns={columns}
            loading={loading}
            rowCount={paginationModel?.rowCount}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
          />
        </>
      ) : null}
      <OverrideMarkupModal
        open={openOverrideModal}
        onClose={() => setOpenOverrideModal(false)}
        markups={overrideMarkups}
        loading={overrideLoading}
        onEdit={handleEditOverride}
        onDelete={handleDeleteOverride}
        onToggleStatus={handleOverrideToggleStatus}
        statusLoadingId={overrideStatusLoadingId}
        onCreate={handleCreateFromOverrideModal}
      />
      <Modal1 open={deleteObj} setOpen={() => setDeleteObj()}>
        <div className="card p-10">
          <MarkupDelete
            forType={"Flights"}
            data={deleteObj}
            cancel={() => setDeleteObj()}
            reload={async () => {
              await load();
              if (isOverrideMarkup(deleteObj)) {
                setOpenOverrideModal(true);
              }
            }}
          />
        </div>
      </Modal1>
      <Modal1
        open={editObj}
        setOpen={(val) => {
          setEditObj(val || undefined);
          if (!val) setIsOverride(false);
        }}
      >
        <div className="p-6">
          <CreateMarkup
            forType={"Flights"}
            reload={load}
            update
            data={editObj}
            override={isOverride || isOverrideMarkup(editObj)}
          />
        </div>
      </Modal1>
    </div>
  );
}

function ActionCol({ params, load }) {
  const { checkPermission } = useAccount();
  const [duplicating, setDuplicating] = useState(false);

  const handleDuplicateMarkup = async () => {
    const payload = { ...params };
    if (payload?._id) delete payload._id;
    if (payload?.updatedAt) delete payload.updatedAt;
    if (payload?.id) delete payload.id;
    payload.status = "Inactive";
    payload.name = payload?.name + " " + "(copy)";
    setDuplicating(true);
    const res = await createFlightPriceAdjustment(payload)?.finally(() =>
      setDuplicating(false),
    );
    if (res?.return) {
      enqueueSnackbar("Markup Duplicated", { variant: "success" });
      load?.();
      // setTimeout(() => {
      //   window.location.reload();
      // }, 300);
    } else {
      enqueueSnackbar(res?.msg, { variant: "error" });
    }
  };

  return (
    <ActionContext.Consumer>
      {(value) => {
        const { setEditObj, changeStatus, setDeleteObj } = value || {};

        return checkPermission(["update:flight-price-adjustment"]) ? (
          <div className="flex gap-2">
            <Switch
              checked={params.status === "Active"}
              onChange={(ev) => changeStatus(ev.target.checked, params)}
            />

            <label
              className="bg-primary/10 rounded-md cursor-pointer p-2 text-primary/30"
              onClick={() => setEditObj(params)}
            >
              <Icon icon="tabler:edit" />
            </label>

            {/* Duplicate */}
            <span
              title="Duplicate markup"
              className="p-2 px-4 flex items-center justify-center bg-gray-100 text-gray-600 rounded-md cursor-pointer hover:bg-gray-200"
              onClick={() => handleDuplicateMarkup()}
            >
              {duplicating ? (
                <div className="primaryLoader"></div>
              ) : (
                <MdContentCopy />
              )}
            </span>

            {/* Delete */}
            <span
              className="p-2 bg-red-100 text-red-500 rounded-md cursor-pointer"
              onClick={() => setDeleteObj(params)}
            >
              <Icon icon="material-symbols-light:delete" />
            </span>
          </div>
        ) : null;
      }}
    </ActionContext.Consumer>
  );
}
